import React from 'react';
import { Link } from 'react-router-dom';
import './PaymentCancelledPage.css';

function PaymentCancelledPage() {
  return (
    <div className="payment-cancelled-page">
      <div className="payment-cancelled-card">
        <div className="payment-cancelled-icon">✕</div>
        <h1 className="payment-cancelled-title">Payment Cancelled</h1>
        <p className="payment-cancelled-sub">
          No worries — your session request is still open.
          You can go back to your dashboard and complete the booking when you're ready.
        </p>
        <div className="payment-cancelled-actions">
          <Link to="/dashboard" className="btn btn-primary">
            Back to Dashboard
          </Link>
          <Link to="/mentors" className="btn btn-ghost">
            Browse Trainers
          </Link>
        </div>
      </div>
    </div>
  );
}

export default PaymentCancelledPage;
